import {
  Checkbox as HeadlessCheckbox,
  CheckboxProps as HeadlessCheckboxProps,
} from "@headlessui/react"
import { Check } from "lucide-react"

import { classNames } from "../../../../lib/classNames"
import { Icon, IconSizes } from "../../../Icon"

export interface CheckboxProps
  extends Omit<HeadlessCheckboxProps, "className" | "checked"> {
  checked: boolean
  className?: string
}

export function Checkbox({
  className,
  onChange,
  ...otherProps
}: CheckboxProps) {
  const disablePointerEvents =
    onChange === undefined && otherProps?.onClick === undefined
  return (
    <HeadlessCheckbox
      className={classNames(
        "rounded-mark border-v2-border-stronger group box-border inline-flex size-4 cursor-pointer items-center justify-center border-2 bg-transparent align-middle",
        "hover:not-data-disabled:ring-6 hover:not-data-disabled:ring-v2-background-active-hover hover:not-data-disabled:not-data-checked:border-v2-border-active",
        "group-hover/checkbox:not-data-disabled:ring-6 group-hover/checkbox:not-data-disabled:ring-v2-background-active-hover group-hover/checkbox:not-data-disabled:not-data-checked:border-v2-border-active",
        "data-disabled:border-v2-border-strong data-disabled:bg-v2-background-surface-tonal data-disabled:cursor-not-allowed",
        "data-checked:border-none data-checked:bg-v2-background-primary data-checked:data-disabled:bg-v2-background-primary-disabled",
        disablePointerEvents && "pointer-events-none",
        className
      )}
      onChange={onChange}
      {...otherProps}
    >
      <Icon
        icon={Check}
        size={IconSizes.ExtraSmall}
        className="text-v2-foreground-inverse group-data-checked:opacity-100 opacity-0"
      />
    </HeadlessCheckbox>
  )
}
